<div style="position: relative; margin-bottom: 20px">
  <img class="header-cover" [src]="coverImageUrl()" alt="Lesson Cover Image" />

  <dc-cropper-modal
    style="position: absolute; top: 10px; left: 20px"
    [buttonLabel]="'Carga una portada'"
    [imgStorageSettings]="coverStorageSettings"
    (imageUploaded)="onImageUploaded($event)"></dc-cropper-modal>

  <p-button
    (click)="generateBanner()"
    class="generate-banner-btn"
    icon="pi pi-sparkles"
    severity="primary"
    [rounded]="true"
    [raised]="true"
    pTooltip="Generar Banner AI"
    tooltipPosition="left"></p-button>

  <p-button class="prompt-visual" icon="pi pi-info" label="Ver Prompts" [link]="true" (click)="showPrompts()" />
</div>

<br />

<!-- Lesson Metadata Editor -->
<dc-lesson-metadata-editor
  [lesson]="lesson"
  [isLoadingLesson]="isLoadingLesson"
  (saveRequest)="saveLesson()"
  (importNotionRequest)="importFromNotion()"
  (improveNotionRequest)="improveNotionWithAI()">
</dc-lesson-metadata-editor>

<div style="margin-top: 30px"></div>

<!-- Component Adder -->
<dc-lesson-component-adder (componentAdded)="onComponentAdded($event)"></dc-lesson-component-adder>

<!-- Display Added Components -->
<div class="added-components-list" style="margin-top: 15px; margin-bottom: 15px">
  <h4>Componentes Agregados:</h4>
  @if (dynamicComponentsArray().length > 0) {
  <ul>
    @for (comp of dynamicComponentsArray(); track comp.id) {
    <li
      >ID: {{ comp.id }} - Tipo: {{ comp.component }}

      <button pButton icon="pi pi-info" (click)="showComponentDetails(comp)"></button>
      <p-button icon="pi pi-pencil" [rounded]="true" severity="warn" (click)="editComponent(comp)"></p-button>
    </li>
    }
  </ul>
  } @else {
  <p>Aún no se han agregado componentes.</p>
  }
</div>

<hr />

<!-- Text Editor and Renderer -->
<p-splitter [style]="{ height: '80vh' }">
  <ng-template pTemplate>
    <ckeditor
      (keydown.control.s)="saveLesson($event)"
      class="text-editor"
      [editor]="editor"
      [ngModel]="lesson()?.textCoded"
      (ngModelChange)="updateLessonProperty('textCoded', $event)">
    </ckeditor>
  </ng-template>

  <ng-template pTemplate>
    <dc-lesson-renderer class="text-editor" [lessonInput]="lesson()"></dc-lesson-renderer>
  </ng-template>
</p-splitter>

<div class="float-button">
  <!-- Removed p-speeddial -->
  <p-button icon="pi pi-save" (click)="saveLesson()" severity="primary" [rounded]="true" [raised]="true" pTooltip="Guardar (Ctrl + S)"> </p-button>
</div>

<hr />

<p-dialog header="Prompts" [modal]="true" [(visible)]="promptsVisible" [style]="{ width: '70%' }">
  <div>
    <h1>Banner</h1>
    <p>{{ prompts?.banner }}</p>
    <h1>Contenido</h1>
    <p>{{ prompts?.content }}</p>
    <h1>Descripción</h1>
    <p>{{ prompts?.description }}</p>
  </div>
</p-dialog>
